import React, { useState } from 'react'

export default function TextForm(props) {

    const UpClick = () => {
        // console.log("Uppercase was clicked + text");
        let newText = text.toUpperCase();
        setText(newText);
        props.showAlert("Text is Converted to Uppercase","success");
    }

    const DownClick = () => {
        let newText = text.toLowerCase();
        setText(newText);
        props.showAlert("Text is Converted to Lowercase","success");
    }

    const CopyClick = () => {
        // let text = document.getElementById("myBox");
        // text.select();
        // navigator.clipboard.writeText(text.value);
        navigator.clipboard.writeText(text);
        // document.getSelection().removeAllRanges();
        props.showAlert("Text copied to clipboard!","success");
    }
    
    const RemoveExtraSpacesClick = () => {
        let newText = text.split(/[ ]+/);
        setText(newText.join(" "));
        props.showAlert("All Extra Spaces has been removed","success");
    }

    const ClearClick = () => {
        let newText = '';
        setText(newText);
        props.showAlert("Text Cleared","success");
    }
    
    const onChangeText = (event) => {
        console.log("on Change Text");
        setText(event.target.value);
    }

    const [text, setText] = useState(''); // Name of the state = 'text' and to update(means change) that 'text' we use 'setText' function
    // text = "new text" //Wrong way to change state

    return (
        <>
        <div className="container" style={{color: props.mode === 'dark' ? '#f8f9fa' : '#042743'}}>
            <h1>{props.heading}</h1>
            <div className=" mb-3">
                <label htmlFor="myBox" className="form-label">Enter the text below :</label>
                {/* <textarea className="form-control" value={text} onChange={onChangeText} style={{backgroundColor: props.mode === 'dark' ? '#17191a' : '#f8f9fa', color: props.mode === 'dark' ? '#f8f9fa' : '#042743', }} id="myBox" rows="10"></textarea> */}
                <textarea className="form-control" value={text} onChange={onChangeText} style={{backgroundColor: props.mode === 'dark' ? '#17191a' : '#f8f9fa', color: props.mode === 'dark' ? '#f8f9fa' : '#042743', borderColor:props.mode === 'dark' ? '#f8f9fa' : '#212529'}} id="myBox" rows="10"></textarea>
            </div>
            <button disabled={text.length===0} type="button" onClick={UpClick} className="btn btn-primary mx-2 ">Convert to Uppercase</button>
            {/* <button type="button" onClick={UpClick} className="btn btn-danger mx-2 ">Convert to Uppercase</button> */}
            <button disabled={text.length===0} type="button" onClick={DownClick} className="btn btn-primary mx-2 ">Convert to Lowercase</button>
            <button disabled={text.length===0} type="button" onClick={CopyClick} className="btn btn-primary mx-2 ">Copy Text</button>
            <button disabled={text.length===0} type="button" onClick={RemoveExtraSpacesClick} className="btn btn-primary mx-2 ">Remove Extra Spaces</button>
            <button disabled={text.length===0} type="button" onClick={ClearClick} className="btn btn-primary mx-2 ">Clear Text</button>
        </div>
        <div className="container my-3" style={{color: props.mode === 'dark' ? '#f8f9fa' : '#042743'}}>
            <h3>You Entered : </h3>
            <p>{text.length} Characters | {text.split(/\s+/).filter((element)=>{return element.length!==0}).length} Words <br/>
            You can read above text in {0.004 * text.split(/\s+/).filter((element)=>{return element.length!==0}).length} Minutes (Average Speed)
            </p>
        </div>
        </>
    )
}
